module.exports = __webpack_public_path__ + "media/assets/plane-6-color-cb3fca68f63ebb0b7615827f50c33a4a.svg";